import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getComments } from '../../actions/comments'

function Comments({ postId, countOnly = false }) {
  const dispatch = useDispatch()
  const commentState = useSelector((state) => state.comment); // match reducer key

  useEffect(() => {
    if (postId) {
      dispatch(getComments(postId));
    }
  }, [dispatch, postId]);

  const comments = commentState.comments[postId] || [];

  if (countOnly) {
    return <span>{comments.length}</span>;
  }


  return (
    <div>
      <div>
        {comments.map((c) => (
          <div key={c.id}>
            <p><strong>{c.postedBy}:</strong> {c.comment}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Comments